import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../component/sidebar";
import { Box, Grid, Typography } from "@mui/material";
import Header from "../../component/header";
import BasicTable from "../tables/BasicTable";
import {
  useGetTestimonialsQuery,
  useUpdateTestimonialMutation,
  useDeleteTestimonialMutation,
  useAddTestimonialMutation,
} from "../../../../services/testimonialSlice";
import TestimonialAddButton from "./testimonialAddButton";

const DashboardTestimonials = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <DashboardTestimonialsPages />
      </Grid>
    </Grid>
  );
};

const DashboardTestimonialsPages = () => {
  const { data, isLoading, isSuccess, isError, error } =
    useGetTestimonialsQuery("getTestimonials");

  const [deleteTestimonial] = useDeleteTestimonialMutation();

  const deleteConfirm = (e, id) => {
    e.preventDefault();
    deleteTestimonial({ id });
  };

  let headers = [];
  let tableData = [];
  let content;
  if (isLoading) {
    content = <p>"Loading..."</p>;
  } else if (isSuccess) {
    headers = [
      "Client Name",
      "Client Photo",
      "Client Testimonial",
      "Active"
    ];
    tableData = [];
    data.ids.forEach((key) => {
      tableData.push({
        "Client Name": data.entities[key].client_name,
        "Client Photo": data.entities[key].client_photo,
        "Client Testimonial": data.entities[key].client_testimonial,
        "Active": data.entities[key].is_active,
        id: data.entities[key].id,
      });
    });
  }
  return (
    <>
      <Box className="table-design-background">
        <Grid container>
          <Grid item xs={6}>
            <Typography className="dashboard-home-page-text">
              Testimonial Lists
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Link to="/dashboard/new/testimonials">
              <TestimonialAddButton />
            </Link>
          </Grid>
        </Grid>
        <Box style={{ padding: "1rem" }}>
          <BasicTable
            headers={headers}
            data={tableData}
            isDelete={true}
            deleteColor={"#f50057"}
            isEdit={true}
            editColor={"#3f51b5"}
            addColor={""}
            tableName={"testimonials"}
            deleteConfirm={deleteConfirm}
            activeSign={['Active']}
          />
        </Box>
      </Box>
    </>
  );
};
export default DashboardTestimonials;
